<template>
<div class="web-chat-button"></div>
</template>

<script>
import webChat from "@/chat.js";
import {
    EventBus
} from "@/event-bus.js";
import {
    globalEventConsts
} from "@/constants.js";
import { useUserStore } from "@/stores/user.js"
import { useSfaStore } from "@/stores/sfa.js"

export default {
    name: "WebChatButton",
    setup() {
        const userStore = useUserStore();
        const sfaStore = useSfaStore();
        return { userStore, sfaStore };
    },
    data() {
        return {
            hasAgentAvailableEventBeenLogged:false,
            hasAgentNotAvailableEventBeenLogged:false,
            userInformation: {
                AgentFirstName: '',
                AgentLastName: '',
                email: '',
                AgentNumber: ''
            }
        }
    },
    methods: {
        openWebChat() {
            // Prepopulate user info if available
            if (this.authState?.idToken?.claims) {
                this.userInformation.AgentNumber = this.userStore.activeAgencyNumber?.toString() || '';
            }
            webChat.openWebChat(this.userInformation);
        },
        // importSalesforceScript() {
        //     webChat.importSalesforceScript().then((embedded_messaging) => {
        //         No agent availability event in new snap-in
        //         Only register chat established event for analytics. Need to confirm if this is available
        //         if (embedded_messaging && embedded_messaging.addEventHandler) {
        //             embedded_messaging.addEventHandler("onChatEstablished", (data) => {
        //                 this.pushEventToGoogleDataLayer("web_chat", "chat_start", data.liveAgentSessionKey ? "success" : "fail", 0);
        //             });
        //         }
        //         Always enable chat option
        //         this.sfaStore.webChatEnabled = true;
        //     });
        // },
    },
    mounted() {
        EventBus.$on(globalEventConsts.OPEN_CHAT, this.openWebChat);
        this.sfaStore.webChatEnabled = true;
        
    },
    watch: {
        'authState.idToken.claims'(userInfo) {
            if (userInfo) {
                    this.userInformation.AgentFirstName=userInfo.AgentFirstName
                    this.userInformation.AgentLastName=userInfo.AgentLastName
                    this.userInformation.email=userInfo.email
            }
        }
    }
};
</script>

<style lang="scss">
.embeddedServiceHelpButton {
    .helpButton {
        .uiButton {
            background-color: #167cac;
            font-family: $font-family-primary;
            &:focus {
                outline: 1px solid #167cac;
            }
            &.helpButtonEnabled {
                position: absolute;
                top: -99999px;
                width: 0;
                height: 0;
            }
            &.helpButtonDisabled {
                display: none;
            }
        }
    }
}
.embeddedServiceSidebar {
    h2,
    p.announcement,
    p.text {
        color: $grayscale-eight;
    }
}
</style>